import { ToggleGroup as DigdirToggleGroup, ToggleGroupItem, } from "@digdir/designsystemet-react";
const ToggleGroup = DigdirToggleGroup;
// For some reason this fixes "ComponentSubcomponent" -> "Component.Subcomponent" in Storybook code snippets
ToggleGroup.displayName = "ToggleGroup";
export { ToggleGroup, ToggleGroupItem, };
//# sourceMappingURL=toggle-group.js.map